var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-chevron-left",
  "use": "ring-icon-chevron-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-chevron-left\"><path d=\"M5.185 7.77L9.854 3.1a.317.317 0 0 1 .229-.1c.088 0 .165.034.231.1l.501.501a.322.322 0 0 1 .101.23.316.316 0 0 1-.101.231L6.877 8l3.938 3.937c.066.067.101.146.101.231s-.034.163-.101.229l-.501.503a.313.313 0 0 1-.46 0L5.185 8.231a.314.314 0 0 1 0-.461z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id